<div class="piece-card-hover-render">
  <idt-common-styles-render
    *ngIf="piece"
    [styles]="piece.settings?.styles">
    @let orientation = orientation$ | async;
    <ng-container>
      <render-link
        *ngIf="pieceLink !== null"
        [lang]="lang"
        [link]="pieceLink"
        [piece]="piece">
        <main class="page-content">
          <div
            class="card">
            <div class="content">
              <div class="title">
                <render-wysiwyg
                  [html]="settings?.general?.titleText"
                  [country]="country"
                  [lang]="lang"
                  [textPaddingTop]="settings?.general?.titlePaddingTop"
                  [textPaddingBottom]="settings?.general?.titlePaddingBottom"
                  [textPaddingLeft]="settings?.general?.titlePaddingLeft"
                  [textPaddingRight]="settings?.general?.titlePaddingRight"
                  [piece]="piece">
                </render-wysiwyg>
              </div>
              <div class="copy">
                <render-wysiwyg
                  [html]="settings?.general?.subtitleText"
                  [country]="country"
                  [lang]="lang"
                  [textPaddingTop]="settings?.general?.subtitlePaddingTop"
                  [textPaddingBottom]="settings?.general?.subtitlePaddingBottom"
                  [textPaddingLeft]="settings?.general?.subtitlePaddingLeft"
                  [textPaddingRight]="settings?.general?.subtitlePaddingRight"
                  [piece]="piece">
                </render-wysiwyg>
              </div>
              <render-wysiwyg
                class="btn"
                [html]="settings?.general?.buttonText"
                [country]="country"
                [lang]="lang"
                [textPaddingTop]="settings?.general?.buttonPaddingTop"
                [textPaddingBottom]="settings?.general?.buttonPaddingBottom"
                [textPaddingLeft]="settings?.general?.buttonPaddingLeft"
                [textPaddingRight]="settings?.general?.buttonPaddingRight"
                [piece]="piece">
              </render-wysiwyg>
            </div>
          </div>
        </main>
      </render-link>
    </ng-container>
  </idt-common-styles-render>
</div>
